<template>
  <div class="hint-page">
    <div class="content">
      <template v-if="!hint">
        <adv-title>The OPERATOR</adv-title>
        <slot></slot>
      </template>
      <span v-else v-html="hint"></span>
    </div>
    <button @click="$emit('close')">CLOSE</button>
  </div>
</template>

<script>
import AdvTitle from "../components/AdvTitle.vue";
export default {
  name: "hint-page",
  props: { hint: String },
  components: { AdvTitle },
};
</script>

<style lang="scss">
@keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.hint-page {
  width: 768px;
  height: 768px;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #000000;
  background-image: url("../assets/images/grid-white-x2.png");
  color: #f1ece6;
  z-index: 99;

  .content {
    position: absolute;
    width: 100%;
    height: 100%;
    padding: 120px;
    font-size: 30px;
    font-weight: 100;
  }

  h1 {
    // margin-top: 28px;
    margin-bottom: 28px;
    text-transform: uppercase;
  }

  button {
    position: absolute;
    bottom: 117px;
    right: 117px;
    width: 60px;
    height: 30px;
    // padding: 10px;
    cursor: pointer;
    font-size: 13px;
    line-height: 32px;
    background-color: #f1ece6;
    color: black;
    border: none;
    outline: none;
    animation: flickerAnimation 3s infinite;
  }
}
</style>
